import { Config } from '@ratehub/base-ui';

import CardComparisonOverviewSection from './CardComparisonOverviewSection';
import CardComparisonInsurancePerksSection from './CardComparisonInsurancePerksSection';
import CardComparisonEligibilitySection from './CardComparisonEligibilitySection';
import CardComparisonRatehubSection from './CardComparisonRatehubSection';
import CardComparisonOtherInformationSection from './CardComparisonOtherInformationSection';


export default {
    maxComparisonCardCount: Config.ENABLE_CC_COMPARISON_PAGE_V2
        ? 99
        : 3,
    numCardsToShow: 3,
    numCardsToShowMobile: 2,
    cardComparisonSections: [
        CardComparisonOverviewSection,
        CardComparisonInsurancePerksSection,
        CardComparisonEligibilitySection,
        CardComparisonRatehubSection,
        CardComparisonOtherInformationSection,
    ],
};
